var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avader-box",style:(`width: ${_vm.size}px;height: ${_vm.size}px`)},[_c('el-avatar',{attrs:{"size":_vm.size,"src":_vm.imgUrl}}),_c('img',{staticClass:"sex",class:_vm.sex ? 'boy' : 'girl',attrs:{"src":_vm.sex ? _vm.boyimg : _vm.girlimg,"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }